import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface DialogAdicionarAnoData {
  ano: number;
}

@Component({
  selector: 'app-dialog-adicionar-ano',
  templateUrl: './dialog-adicionar-ano.component.html',
  styleUrls: ['./dialog-adicionar-ano.component.css']
})
export class DialogAdicionarAnoComponent {
  public constructor(
    private dialogRef: MatDialogRef<DialogAdicionarAnoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogAdicionarAnoData
  ) { }

  public confirmar(): void {
    this.dialogRef.close(this.data.ano);
  }

  public cancelar(): void {
    this.dialogRef.close();
  }
}
